import React, { useEffect, useState } from "react";
import share_icon from "../../../assets/images/share_icon.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { usePreview } from "../../../context/PreviewContextProvider";

// Card component to display NFT details
const Card = ({
  card,
  btn,
  download,
  overlay,
  overlayText,
  newest,
  onBtnOpen,
  onShare,
  isOwner,
  delete_icon,
  onDelete
}) => {
  const { data } = usePreview(); // Custom hook to access context data
  const [address, setAddress] = useState(""); // State for formatted address
  const imgClass = overlay ? "card__img img-overlay" : "card__img"; // Conditional class for image overlay
  const download_btn_style = download ? { visibility: "visible" } : { visibility: "hidden" }; // Style for download button
  const delete_btn_style = delete_icon ? { visibility: "visible" } : { visibility: "hidden" }; // Style for delete button

  // Effect to format and set the NFT address when the address changes
  useEffect(() => {
    const checkAddress = async () => {
      if (card.address) {
        const trunc_address = ` ${card.address.slice(0, 6)}...${card.address.slice(card.address.length - 4)} `;
        setAddress(trunc_address); // Set truncated address
      }
    };
    checkAddress(); // Call the function to check address
  }, [card.address]); // Depend on card.address for updates

  // Function to conditionally render the button based on props
  const showButton = () => {
    if (btn & btn !== "Buy") {
      return (
        <button
          className="card__btn"
          style={{ color: data.web_main_color, borderColor: data.web_main_color }} // Button style based on context color
          onClick={() => { onBtnOpen(card, btn) }} // Trigger button action
        >
          {btn}
        </button>
      );
    }
    else if (btn === "Buy") {
      return (
        <button
          className="card__btn"
          style={{ color: data.web_main_color, borderColor: data.web_main_color }} // Button style based on context color
        >
          {btn}
        </button>
      );
    }
    else if (isOwner) {
      // Render text if the user is the owner and no button is provided
      return <div className="card__text card__addr tooltip">constant.MY_NFT</div>;
    }
  };

  // Function to show overlay text if provided
  const showOverlayText = () => {
    if (overlayText) {
      return <h3 className="card__img-overlay-text">Sample</h3>;
    }
  };

  // Function to show "Newest" ribbon if applicable
  const showNewest = () => {
    if (newest) {
      return (
        <div className="ribbon">
          <span>Newest</span>
        </div>
      );
    }
  };

  // Function to show "Not for sale" ribbon if applicable
  const showNotForSale = () => {
    if (!card.forSale && isOwner !== undefined) {
      return (
        <div className="ribbon" style={{ backgroundColor: data.web_main_color }}>
          <span>Not for sale</span>
        </div>
      );
    }
  };

  // Render the card component
  return (
    <div className="nft_card" data-token={card?.tokenId} data-siteindex={card?.siteTokenIndex}>
      <div className="card__top-box">
        <img className={imgClass} src={card.image} alt="NFT" /> {/* Display NFT image */}
        {showOverlayText()} {/* Show overlay text if applicable */}
        {showNewest()} {/* Show "Newest" ribbon if applicable */}
        {showNotForSale()} {/* Show "Not for sale" ribbon if applicable */}
        <div
          className="card__download-btn"
          style={download_btn_style}
          onClick={() => onShare(card)} // Trigger sharing action
        >
          <img
            className="card__download-icon"
            src={share_icon}
            alt="download"
          />
        </div>
        <div
          className="card__download-btn"
          style={delete_btn_style}
          onClick={onDelete} // Trigger delete action
        >
          <div className="card__download-icon">
            <FontAwesomeIcon icon={faTrash} style={{ height: '1.8rem', color: '#505050' }} />
          </div>
        </div>
      </div>
      <div className="card__bottom-box">
        <div className="card__body">
          <div className="card__body-top">
            <div className="top-group">
              <h3 className="card__title" style={{ color: data.web_main_color }}>{card.name === null ? "NFT" : card.name}</h3> {/* Display NFT title */}
              <h3 className="card__text nft-price">{card.price} AVAX</h3> {/* Display NFT price */}
            </div>
          </div>
          <div className="card__body-bottom">
            <span className="card__text card__addr">{address}</span> {/* Display formatted address */}
            {showButton()} {/* Show action button or owner text */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Card); // Export the Card component, wrapped in React.memo for performance optimization
